import { useCallback, useEffect, useRef, useState } from "react";
import {
  LayerGroup,
  LayersControl,
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
  useMapEvent,
} from "react-leaflet";

import "leaflet/dist/leaflet.css";
import MapEvents from "./MapEvents";
import icon from "./Marker";
import "reactjs-popup/dist/index.css";

import {
  Slider,
  Select,
  Button,
  Space,
  Tooltip,
  theme,
  ConfigProvider,
  message,
} from "antd";
import DarkModeToggle from "react-dark-mode-toggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBackwardStep,
  faCopy,
  faHome,
  faMapMarker,
} from "@fortawesome/free-solid-svg-icons";
import CopyToClipboard from "react-copy-to-clipboard";
import L from "leaflet";

import "leaflet-measure-ext/dist/leaflet-measure.css";
import "leaflet-measure-ext/dist/leaflet-measure";
import "./styles/custom.css";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import FullscreenControl from "./FullScreen";
import VectorData from "./VectorData";

const { defaultAlgorithm, darkAlgorithm } = theme;
var isdBounds = [
  [33.4874, 72.8116],
  [33.8115, 73.391],
];

function ZoomToSelectedBounds(props) {
  const map = useMap();

  useEffect(() => {
    map.fitBounds(props.bounds);
  }, [map, props.bounds]);

  return <></>;
}

function LeafletRuler(props) {
  const map = useMap();

  useEffect(() => {
    L.control.measure({ position: "topleft" }).addTo(map);
  }, [map]);

  return <></>;
}

function LocationMarker({
  saveMarkers,
  updateCenter,
  updateAddress,
  selectedVal,
}) {
  const navigate = useNavigate();
  const [position, setPosition] = useState([0, 0]);
  const map = useMapEvent("click", (e) => {
    updateCenter([e.latlng.lat, e.latlng.lng]);
    // updateMarkerPos([0, 0]);
    setPosition(e.latlng);
    saveMarkers(e.latlng);
    navigate({
      search:
        "m=1," + parseFloat(e.latlng.lat) + "," + parseFloat(e.latlng.lng),
    });
    // console.log(window.location.href);
    updateAddress(window.location.href);
    // setMarkerDrawn(1);
    // map.flyTo(e.latlng, map.getZoom());
    // updatePermalink();
  });

  return position === null ? null : (
    <Marker position={position} icon={icon}>
      <Popup>You clicked here</Popup>
    </Marker>
  );
}

function Movement({
  updateZoom,
  updateCenter,
  updateMarkerPos,
  updatePermalink,
}) {
  const map = useMapEvent("moveend", () => {
    // updateZoom(map.getZoom());
    // updateCenter([map.getCenter().lat, map.getCenter().lng]);
    updateMarkerPos([0, 0]);
    // updatePermalink();
  });
}

function MapWrapper() {
  const routeParams = useParams();
  const loca = useLocation();
  const [messageApi, contextHolder] = message.useMessage();

  const info = () => {
    messageApi.info("Link copied to clipboard");
  };
  let saveMarkers = (e) => {
    setMarker(1);
    setCenter(e);
    setmarkerPos([e.lat, e.lng]);
    // updatePermalink();
  };
  let setMarkerDrawn = (e) => {};
  let selectedVal = (e) => {
    return selVal;
  };
  let updateAddress = (e) => {
    setaddress(e);
  };
  let updateCenter = (e) => {
    setCenter(e);
  };
  let updateZoom = (e) => {
    setZoom(e);
  };
  let updateMarkerPos = (e) => {
    setmarkerPos([0, 0]);
  };
  const [address, setaddress] = useState("");
  const [shouldUpdate, setshouldUpdate] = useState(true);
  const [marker, setMarker] = useState(0);
  const [markerPos, setmarkerPos] = useState([0, 0]);
  const mapRef = useRef();
  const [zoom, setZoom] = useState(4);
  const [center, setCenter] = useState([33.6844, 73.0479]);
  const [bounds, setBounds] = useState(isdBounds);
  const [opac, setOpac] = useState(1);
  const [color, setColor] = useState("#fff");
  const [attr, setattr] = useState("");
  const [selVal, setselVal] = useState("");
  const [olColor, setolColor] = useState("#333");
  const [olFontcolor, setolFontcolor] = useState("#fff");
  const [olHighcolor, setolHighcolor] = useState("#fff");
  const [fsContent, setfsContent] = useState(
    'url("data:image/png;base64,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")'
  );
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isDrawMode, setIsDrawMode] = useState(false);
  // const [layers, setLayers] = useState([]);

  const modeChange = () => {
    setIsDarkMode(!isDarkMode);
    isDarkMode ? setColor("#fff") : setColor("#000");
    isDarkMode ? setColor("#fff") : setColor("#000");
    isDarkMode ? setolColor("#333") : setolColor("#fff");
    isDarkMode ? setolHighcolor("#fff") : setolHighcolor("#333");
    isDarkMode ? setolFontcolor("#fff") : setolFontcolor("#333");
    isDarkMode
      ? setfsContent(
          'url("data:image/png;base64,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")'
        )
      : setfsContent(
          'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAA0CAYAAACU7CiIAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACoSURBVFiF7ZZhDoAgCIWxdbF3suxkHM3+1FaOmNqyIr6fiHuJTyKklKgHQxcVF7rCKAUBiA5h5tCSR/T0iTakL9PWz05IZNEM3YSCt6BvCgFI2ps4Q9v3k9Ldgdrr8nrX9LYc7wwu5EIu9KCQT6rq+r8mVbV0ewBEIpqy8MzMsWR/8f+oxmES9u7olZPqLKQeYtqkWuy61V2xND/H3h35pNqMPTPYE1oAnZZStKN8jj8AAAAASUVORK5CYII=")'
        );
    document.documentElement.style.setProperty("--ll-btn-bg-color", olColor);
    document.documentElement.style.setProperty(
      "--ll-btn-fs-content",
      fsContent
    );
    document.documentElement.style.setProperty(
      "--ll-btn-txt-color",
      olFontcolor
    );
    document.documentElement.style.setProperty(
      "--ll-accent-background-color",
      olHighcolor
    );
  };

  useEffect(() => {
    // window.addEventListener("popstate", function (event) {
    //   if (event.state === null) {
    //     return;
    //   }
    //   console.log();
    //   setselVal(event.state.s);
    //   setCenter([event.state.lng, event.state.lat]);
    //   setZoom(event.state.z);
    //   setMarker(event.state.m.split(",")[0]);
    //   if (event.state.m.split(",")[0] === "1") {
    //     setmarkerPos([event.state.m.split(",")[1], event.state.m.split(",")[2]]);
    //   }
    //   try {
    //     fetch(
    //       `../geoserver/rest/workspaces/plotsmap/coveragestores/${event.state.s}.tif/coverages/${event.state.s}.json`,
    //       {
    //         method: "get",
    //         headers: new Headers({
    //           Authorization: "Basic " + btoa("admin:$hakrial@177@"),
    //           "Content-Type": "application/x-www-form-urlencoded",
    //         }),
    //       }
    //     )
    //       .then((response) => response.json())
    //       .then((data) => {
    //         var exte = data.coverage.latLonBoundingBox;
    //         setBounds([
    //           [parseFloat(exte.maxy), parseFloat(exte.maxx)],
    //           [parseFloat(exte.miny), parseFloat(exte.minx)],
    //         ]);
    //       });
    //   } catch (e) {}
    // });
    // fetch("../geoserver/rest/workspaces/plotsmap/layers.json", {
    //   method: "get",
    //   headers: new Headers({
    //     Authorization: "Basic " + btoa("admin:$hakrial@177@"),
    //     "Content-Type": "application/x-www-form-urlencoded",
    //   }),
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     setLayers(data.layers.layer);
    //     // setfilteredlayers(data.layers.layer);
    //   });
    // if (window.location.hash !== "") {
    //   const hash = window.location.hash.replace("#", "");
    //   const parts = hash.split("&");
    //   if (parts.length === 2) {
    //     var soc = parts[0].replace("s=", "");
    //     var m = parts[1].replace("m=", "");
    //
    //     // setCenter([parts[1].replace("lat=", ""), parts[2].replace("lng=", "")]);
    //     // setZoom(parts[3].replace("z=", ""));
    //     setMarker(m.split(",")[0]);
    //     if (m.split(",")[0] === "1") {
    //       setmarkerPos([m.split(",")[1], m.split(",")[2]]);
    // http://localhost:3000/s=Islamabad_AWT_D-18&m=1,33.651740399458895,72.82870731525499
    //     }
    try {
      //       setattr(soc.split("_").join(" "));
      // let params = routeParams["*"].split("&");
      //Umair
      let soc = loca.pathname.replace("/s=", "");
      document.title = "Plotsmap - " + soc;
      setselVal(soc);
      if (soc === "Rawalpindi_CSC") soc = "Rawalpindi_CSC_Masterplan";
      fetch(
        `../geoserver/rest/workspaces/plotsmap/coveragestores/${soc}.tif/coverages/${soc}.json`,
        {
          method: "get",
          headers: new Headers({
            Authorization: "Basic " + btoa("admin:$hakrial@177@"),
            "Content-Type": "application/x-www-form-urlencoded",
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          var exte = data.coverage.latLonBoundingBox;
          setBounds([
            [parseFloat(exte.maxy), parseFloat(exte.maxx)],
            [parseFloat(exte.miny), parseFloat(exte.minx)],
          ]);
          let m = loca.search.replace("?m=", "").split(",");
          if (m[0] === "1") {
            setMarker(1);
            setmarkerPos([parseFloat(m[1]), parseFloat(m[2])]);
          }
        });
    } catch (e) {}
    // }
    // }
  }, []);

  const sliderChange = useCallback((e) => {
    setOpac(e);
  }, []);

  const enableDrawing = useCallback(
    (e) => {
      setIsDrawMode(!isDrawMode);
    },
    [isDrawMode]
  );
  const goBack = useCallback((e) => {
    window.history.back();
  }, []);

  // let shouldUpdate = true;
  const updatePermalink = function () {
    if (!shouldUpdate) {
      setshouldUpdate(true);
      return;
    }
    const hash =
      "#s=" +
      selVal +
      // "&lat=" +
      // parseFloat(center[0]) +
      // "&lng=" +
      // parseFloat(center[1]) +
      // "&z=" +
      // Math.floor(zoom) +
      "&m=" +
      marker +
      "," +
      markerPos[0] +
      "," +
      markerPos[1];
    console.log(hash);
    const state = {
      s: selVal,
      lat: center[0],
      lng: center[1],
      z: zoom,
      m: marker,
    };
    window.history.pushState(state, "map", hash);
    setaddress(window.location.href);
  };

  const handleChange = (value) => {
    if (value.length === 0) return;
    setselVal(value);
    setattr(value.split("_").join(" "));
    document.title = "Plotsmap - " + value;
    const state = {
      s: value.replace("plotsmap:", ""),
      lat: center[0],
      lng: center[1],
      z: zoom,
      m: marker,
    };
    window.history.pushState(
      state,
      "map",
      `#s=${value.replace("plotsmap:", "")}&lat=${center[0]}&lng=${
        center[1]
      }&z=${zoom}`
    );
    fetch(
      `../geoserver/rest/workspaces/plotsmap/coveragestores/${value.replace(
        "plotsmap:",
        ""
      )}.tif/coverages/${value.replace("plotsmap:", "")}.json`,
      {
        method: "get",
        headers: new Headers({
          Authorization: "Basic " + btoa("admin:$hakrial@177@"),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        var exte = data.coverage.latLonBoundingBox;
        setBounds([
          [parseFloat(exte.maxy), parseFloat(exte.maxx)],
          [parseFloat(exte.miny), parseFloat(exte.minx)],
        ]);
      });
  };

  return (
    <>
      <ConfigProvider
        theme={{
          algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
        }}
      >
        <MapContainer
          ref={mapRef}
          center={center}
          zoom={zoom}
          className="map-container"
          maxZoom={27}
          // whenReady={updatePermalink}
        >
          {selVal === "Rawalpindi_CSC_Masterplan" ? <VectorData /> : ""}
          <LayersControl position="topright">
            <LayersControl.BaseLayer name="Satellite" checked={true}>
              <LayerGroup name="Satellite">
                <TileLayer
                  maxZoom={27}
                  url="http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"
                  className={isDarkMode ? "map-tiles" : ""}
                />
                <TileLayer
                  maxZoom={27}
                  url="http://mt0.google.com/vt/lyrs=h&hl=en&x={x}&y={y}&z={z}"
                />
              </LayerGroup>
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Maps">
              <TileLayer
                name="Maps"
                maxZoom={27}
                url="http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}"
                className="map-tiles"
              />
            </LayersControl.BaseLayer>
            <TileLayer
              opacity={opac}
              maxZoom={27}
              url={`../geoserver/gwc/service/tms/1.0.0/plotsmap:${selVal}@EPSG:900913@png/{z}/{x}/{-y}.png`}
              zIndex={5}
              attribution={`&copy; PlotsMap <a href="https://www.plotsmap.com/" target="_blank">${attr}</a>`}
            />
          </LayersControl>
          <MapEvents />
          <ZoomToSelectedBounds bounds={bounds} />
          <LeafletRuler />
          {isDrawMode ? (
            <LocationMarker
              saveMarkers={saveMarkers}
              updateCenter={updateCenter}
              updateAddress={updateAddress}
              selectedVal={selectedVal}
            />
          ) : null}
          {/* <Movement
            updateZoom={updateZoom}
            updateCenter={updateCenter}
            updateMarkerPos={updateMarkerPos}
            updatePermalink={updatePermalink}
          /> */}
          {marker === 1 ? (
            <Marker position={markerPos} icon={icon}></Marker>
          ) : (
            ""
          )}
          {/* <FullscreenControl /> */}
        </MapContainer>
        <div
          style={{
            position: "fixed",
            zIndex: 100000,
            top: "4.5em",
            right: ".75em",
          }}
        >
          <Space direction="vertical">
            <DarkModeToggle
              onChange={modeChange}
              checked={isDarkMode}
              size={45}
            />
            <Tooltip placement="left" title="Draw a Marker">
              <Button onClick={enableDrawing}>
                <FontAwesomeIcon icon={faMapMarker} color={olColor} />
              </Button>
            </Tooltip>
            <Tooltip placement="left" title="Copy to Clipboard">
              <CopyToClipboard text={address} onCopy={info}>
                <Button>
                  <FontAwesomeIcon icon={faCopy} color={olColor} />
                </Button>
              </CopyToClipboard>
            </Tooltip>
            {/* <Tooltip placement="left" title="Go to Plotsmap">
              <Button
                onClick={() => {
                  window.location.replace("https://plotsmap.com");
                }}
              >
                <FontAwesomeIcon icon={faHome} color={olColor} />
              </Button>
            </Tooltip> */}
          </Space>
        </div>
        <div
          style={{
            position: "fixed",
            zIndex: 500,
            top: ".75em",
            left: "3em",
            height: "10em",
          }}
        >
          {/* <Tooltip title="List of Cities">
            <Select
              showSearch
              mode="single"
              dropdownStyle={{ zIndex: 2000 }}
              style={{
                width: "20em",
                backgroundColor: "olColor",
                color: "olFontcolor",
              }}
              placeholder="Cities List"
              onChange={handleParentChange}
              options={[
                {
                  value: "Islamabad",
                  name: "Islamabad",
                },
                {
                  value: "Lahore",
                  name: "Lahore",
                },
                {
                  value: "Rawalpindi",
                  name: "Rawalpindi",
                },
              ]}
              value={parentSelVal}
              fieldNames={{ label: "name", value: "name" }}
            />
          </Tooltip> */}
          {/* <Tooltip title="List of Societies">
            <Select
              showSearch
              mode="single"
              dropdownStyle={{ zIndex: 2000 }}
              style={{
                width: "15em",
                backgroundColor: "olColor",
                color: "olFontcolor",
              }}
              placeholder="Socities Map"
              onChange={handleChange}
              options={layers}
              value={selVal}
              fieldNames={{ label: "name", value: "name" }}
            />
          </Tooltip> */}
        </div>
        <div
          style={{
            position: "fixed",
            zIndex: 500,
            top: "10.5em",
            left: ".6em",
            height: "10em",
          }}
        >
          <Tooltip placement="left" title="Draw a Marker">
            <Slider
              trackStyle={{
                border: ".5px solid " + olColor,
                backgroundColor: olFontcolor,
                width: "1em",
                borderRadius: "10px",
                marginLeft: "-3px",
              }}
              tooltip={{ open: false }}
              min={0}
              max={1}
              step={0.1}
              reverse={false}
              vertical
              value={opac}
              onChange={(e) => sliderChange(e)}
            />
          </Tooltip>
        </div>
        {contextHolder}
      </ConfigProvider>
    </>
  );
}

export default MapWrapper;
